import { Helmet } from '@dr.pogodin/react-helmet'
import { Box, Button, Container, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useEffect } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import gtm from '@/lib/gtm'

const BillingInactive = () => {
    const theme = useTheme()
    const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'))

    useEffect(() => {
        gtm.push({ event: 'page_view' })
    }, [])

    return (
        <>
            <Helmet>
                <title>Subscription inactive</title>
            </Helmet>
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    minHeight: '100%',
                    px: 3,
                    py: '80px'
                }}
            >
                <Container maxWidth="lg">
                    <Typography
                        align="center"
                        color="textPrimary"
                        variant={mobileDevice ? 'h4' : 'h1'}
                    >
                        Subscription inactive
                    </Typography>
                    <Typography
                        align="center"
                        color="textSecondary"
                        sx={{ mt: 0.5 }}
                        variant="subtitle2"
                    >
                        Your organisation&apos;s subscription is inactive, so
                        this page has been paused. Please ask an administrator to
                        renew the subscription to restore access.
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mt: 6
                        }}
                    >
                        <Button
                            color="primary"
                            component={RouterLink}
                            to="/"
                            variant="outlined"
                        >
                            Back to Home
                        </Button>
                    </Box>
                </Container>
            </Box>
        </>
    )
}

export default BillingInactive
